import './index.css';
import logo from '../../assets/autosense-logo.png'

export const Header = () => (
  <header className='header-container'>
    <a href={`${process.env.REACT_APP_LEARN_MORE_URL}`} className='logo'>
      <img src={logo} alt='autoSense-Logo' />
    </a>
  </header>
)